import { render, staticRenderFns } from "./HeroBadge.vue?vue&type=template&id=12767b9f&"
import script from "./HeroBadge.vue?vue&type=script&lang=js&"
export * from "./HeroBadge.vue?vue&type=script&lang=js&"
import style0 from "./HeroBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports